import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { MENU_SIDEBAR_KEYS,LANDING_KEYS, DIALOG_KEYS } from '../../utils/translation-constants'
import FaqService from '../../services/faq.service'
import Loading from 'custom/assets/loaders/Loading'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'

export default function FAQ() {
  const { t } = useTranslation()
  const [noRecords, setNoRecords] = useState(false)
  const [frequentlyAskedQuestions, setFrequentlyAskedQuestions] = useState([])
  const [isSubmitting, setSubmitting] = useState(false)

  useEffect(() => {
    const fetchFaqs = async () => {
      setSubmitting(true)
      try {
        const response = await FaqService.getFAQ()
        setFrequentlyAskedQuestions(response.faqList)
        setNoRecords(response.faqList.length > 0 ? false : true)
        setSubmitting(false)
      } catch (err) {
        setSubmitting(false)
      }
    }
    fetchFaqs()
  }, [])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard breadCumKey='FAQ' showEmptySpace={true} keyPath={'FAQ'}>
      <div>
        <div className='heading-style'>{t(MENU_SIDEBAR_KEYS.FAQ)}</div>
        {isSubmitting === true ? renderLoading() : <div />}

        {frequentlyAskedQuestions.map((x, i) => (
          <QuestionCard key={i} question={x.question} answer={x.answer} />
        ))}
        {noRecords && frequentlyAskedQuestions.length === 0 && <p>{t(LANDING_KEYS.NO_RECORD)}</p>}
      </div>
    </LayoutWithOutAccountCard>
  )
}

function QuestionCard({ question, answer }) {
  const [expanded, setExpanded] = useState(false)

  return (
    <div>
      <div
        style={{
          borderRadius: '19px',
          boxShadow:
            'inset 0 -3px 8px 0 rgba(255, 255, 255, 0.82), inset 0 -6px 15px 0 #ffffff,0 6px 30px 0 rgba(204, 204, 204, 0.44)',
        }}
        className='cursor-pointer my-4 card shadow-sm'
        onClick={() => setExpanded(!expanded)}>
        <div className='card-body pt-4 pb-3'>
          <h6 className='font-weight-bold' style={{fontSize: '13px'}}>{question}</h6>
          {expanded && <p className='mt-4 text-justify' style={{fontSize: '12px'}}>{answer}</p>}
        </div>
      </div>
    </div>
  )
}
